import React from 'react'
import styled from 'styled-components'
import { FacebookPosts } from '../../components/Social/FacebookPosts'
import { TwitterPosts } from '../../components/Social/TwitterPosts'
import { SCREEN_SIZE, STYLES } from '../../static/style'

const StyledSchoolSocialSection = styled.div`
  width: 100%;
  padding: 1rem;
`

const Posts = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  > * {
    margin-bottom: ${STYLES.GUTTER};
  }
  ${SCREEN_SIZE.SM} {
    > * {
      margin-right: ${STYLES.GUTTER};
      margin-bottom: 0;
    }
  }
`

interface ISchoolSocialSectionProp {
  facebook?: string
  twitter?: string
  onLoadSuccess?: () => void
}

const SchoolSocialSection: React.FC<ISchoolSocialSectionProp> = ({
  facebook,
  twitter,
  onLoadSuccess,
}) => {
  if (!facebook && !twitter) {
    return null
  }
  const facebookUrl = facebook && facebook.replace(/zh-cn/, 'www')
  return (
    <StyledSchoolSocialSection>
      <Posts>
        {facebook && (
          <FacebookPosts
            facebookPageUrl={facebookUrl}
            onLoadSuccess={onLoadSuccess}
          />
        )}
        {twitter && (
          <TwitterPosts url={twitter} onLoadSuccess={onLoadSuccess} />
        )}
      </Posts>
    </StyledSchoolSocialSection>
  )
}

export { SchoolSocialSection }
